import React from 'react';
import PropTypes from 'prop-types';
import { MediaProvider } from '../../contexts/media';
import { BREAKPOINTS } from '../../constants';
import GlobalSEO from '../global-seo';
import Navbar from '../navbar';
import Footer from '../footer';
import './layout.scss';

function Layout({ children }) {
  return (
    <div className="layout">
      <MediaProvider breakpoints={BREAKPOINTS}>
        <GlobalSEO />
        <Navbar />

        <main className="layout__main">
          {children}
        </main>

        <Footer />
      </MediaProvider>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
